import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionOneImage from "hooks/form/blocks/useSectionOneImage";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum, DesktopOrMobile } from "types/enums";

function SectionOneImageForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, setDesktopMobileImage, formHook } = useSectionOneImage();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    const desktopMobileText = React.useMemo(() => {
        if (blockId === BlockEnum.SectionOneImageFull) {
            return {
                desktop: "2000x 1125px (max 500KB)",
                mobile: "1200x 675px (max 250KB)",
            };
        }

        return {
            desktop: "1500x844px (max 400KB)",
            mobile: "1200x 675px (max 250KB)",
        };
    }, [blockId]);

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <GridColumn>
                    <ExtensionsProporsionInfo
                        desktopText={desktopMobileText.desktop}
                        mobileText={desktopMobileText.mobile}
                        proportion={"16:9"}
                    />

                    <GridRow>
                        <GridItem>
                            <h3>Immagine</h3>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Desktop"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.desktop)
                                }
                                file={form.img.desktop}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("img.desktop")}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Mobile"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.mobile)
                                }
                                file={form.img.mobile}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("img.mobile")}
                            />
                        </GridItem>
                    </GridRow>
                </GridColumn>
            )}
        </>
    );
}

export default SectionOneImageForm;
